import { Component, EventEmitter, OnDestroy, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import Quill from 'quill';


@Component({
    templateUrl: './rich-text.component.html',
    styleUrls: ['./rich-text.component.scss'],
    selector: 'rich-text',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi:true,
        useExisting: forwardRef(() => RichTextComponent),
      },
      // {
      //   provide: NG_VALIDATORS, 
      //   useExisting: forwardRef(() => RichTextComponent),
      //   multi: true,
      // },
  ]
})

export class RichTextComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private quillEditor: Quill;
  private onChangeCallback: (value: string) => void;
  private onTouchedCallback: () => void;

  @Output() valueChanged = new EventEmitter<String>();


  ngOnInit(): void {
    this.quillEditor = new Quill('#quill-editor', {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline'],
          ['link']
        ]
      }
    });

    this.quillEditor.on('text-change', () => {
      this.onChangeCallback(this.quillEditor.root.innerHTML);
      this.onTouchedCallback();
    });
  }

  ngOnDestroy(): void {
    this.quillEditor.off('text-change');
  }

  writeValue(value: string): void {
    this.quillEditor.root.innerHTML = value || '';
  }

  registerOnChange(callback: (value: string) => void): void {
    this.onChangeCallback = callback;
  }

  registerOnTouched(callback: () => void): void {
    this.onTouchedCallback = callback;
  }

  setDisabledState(isDisabled: boolean): void {
    this.quillEditor.enable(!isDisabled);
  }
}